import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/var/www/html/frontend/app/layouts/default.vue").then(m => m.default || m)),
  error: defineAsyncComponent(() => import("/var/www/html/frontend/app/layouts/error.vue").then(m => m.default || m)),
  library: defineAsyncComponent(() => import("/var/www/html/frontend/app/layouts/library.vue").then(m => m.default || m))
}